import { Component, OnInit, Input } from '@angular/core';
import { Vehicle } from 'src/app/shared/model/vehicle';
import { DealerService, BidStatus, AlternativeBidRequest } from 'src/app/shared/services/dealer.service';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { GaEventsService } from 'src/app/shared/services/ga-events.service';
import { UserInfo } from '@app/store/session/session.store';
import { SessionService } from '@app/store/session/session.service';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-make-final-bid',
  templateUrl: './make-final-bid.component.html',
  styleUrls: ['./make-final-bid.component.scss']
})
export class MakeFinalBidComponent implements OnInit {
  @Input() vehicle: Vehicle;
  @Input() disableConfirmationModal = false;

  loading = false;
  finalBidErrorMessage: string;
  showFinalBidModal = false;
  showAlternativeBidForm = false;
  showOpenComment = false;
  alternativeBid: AlternativeBidRequest;
  alternativeBidErrorMessage: string;
  alternativeBidSuccess: boolean;
  showLatePaymentLink: boolean;
  latePaymentQueryParams = { expandedStatuses: '["SOLD_NO_PAYMENT"]' };
  user: UserInfo;

  valueControl = new FormControl('');
  valueControlAlternativeBid = new FormControl('alternativeBidForm');

  constructor(
    private dealerService: DealerService,
    private router: Router,
    private eventsService: GaEventsService,
    private sessionService: SessionService) { }

  ngOnInit() {
    this.sessionService.getUser().subscribe(u => this.user = u);
    this.alternativeBid = new AlternativeBidRequest();
  }

  makeFinalBid(): void {
    this.finalBidErrorMessage = undefined;
    this.showLatePaymentLink = undefined;
    this.loading = true;
    this.dealerService.putFinalBid(this.vehicle.id, this.vehicle.finishValue)
      .subscribe(result => {
        if (result.success) {
          this.vehicle.ownsCurrentBid = true;
          this.vehicle.currentPrice = this.vehicle.finishValue;
          this.vehicle.status = 'SOLD';
          this.vehicle.soldAt = new Date();
          this.closeFinalBidModal();
          this.eventsService.fireEvent('Arremate', 'Envio', 'vehicleId: ' + this.vehicle.id);

          window.scrollTo(0, 0);

          this.router.navigate(['/arrematar/veiculos/', this.vehicle.slug + '-bought', this.vehicle.id]);
        } else {
          this.finalBidErrorMessage = BidStatus[result.status];
          if (BidStatus[result.status] === BidStatus.LATE_PAYMENT) {
            this.showLatePaymentLink = true;
          }
        }
        this.loading = false;
      });
  }

  openFinalBidModal(): void {
    this.showFinalBidModal = true;
  }

  closeFinalBidModal(): void {
    this.showFinalBidModal = false;
  }

}
